import { ActionsUnion, createAction } from "store/helper";

import { CRUDAction, RequestAction, createEntityActionNames, createEntityActions } from "../actions";

import {
  IRule,
  IRuleCreateFailurePayload,
  IRuleCreatePayload,
  IRuleCreateSuccessPayload,
  IRuleSyncDeletePayload,
  IRuleUpdateCountersPayload,
  IRuleUpdatePayload,
} from "./interfaces";

export const RulesActionsNames = {
  ...createEntityActionNames("RULES"),
  SYNC_DELETE: "ENTITIES/RULES/SYNC_DELETE",
  UPDATE_COUNTERS: "ENTITIES/RULES/UPDATE_COUNTERS",
};
export const RulesActions = {
  ...createEntityActions<IRule>(RulesActionsNames),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  update: (payload: IRuleUpdatePayload) =>
    createAction(RulesActionsNames[CRUDAction.UPDATE][RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  create: (payload: IRuleCreatePayload) =>
    createAction(RulesActionsNames[CRUDAction.CREATE][RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createSuccess: (payload: IRuleCreateSuccessPayload) =>
    createAction(RulesActionsNames[CRUDAction.CREATE][RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createFailure: (payload: IRuleCreateFailurePayload) =>
    createAction(RulesActionsNames[CRUDAction.CREATE][RequestAction.FAILURE], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateCounters: (payload: IRuleUpdateCountersPayload) => createAction(RulesActionsNames.UPDATE_COUNTERS, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  syncDelete: (payload: IRuleSyncDeletePayload) => createAction(RulesActionsNames.SYNC_DELETE, payload),
};

export enum RulesRequestSelectorsNames {
  FETCH_RULES_COLLECTION_REQUEST = "ENTITIES/RULES/FETCH_COLLECTION",
  CREATE_RULE_REQUEST = "ENTITIES/RULES/CREATE",
  UPDATE_RULE_REQUEST = "ENTITIES/RULES/UPDATE",
}

export type RuleAction = ActionsUnion<typeof RulesActions>;
